import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="products"
export default class extends Controller {
  static targets = ["product", "searchInput", "categoryButton"]

  connect() {
    this.activeCategory = "All"
  }

  filter(event) {
    const category = event.currentTarget.dataset.category
    this.activeCategory = category

    // Update buttons
    this.categoryButtonTargets.forEach(btn => {
      if (btn.dataset.category === category) {
        btn.classList.add("bg-blue-600", "text-white", "shadow-lg")
        btn.classList.remove("bg-slate-100", "text-slate-600", "hover:bg-slate-200")
      } else {
        btn.classList.remove("bg-blue-600", "text-white", "shadow-lg")
        btn.classList.add("bg-slate-100", "text-slate-600", "hover:bg-slate-200")
      }
    })

    this.applyFilters()
  }

  search() {
    this.applyFilters()
  }

  applyFilters() {
    const query = this.searchInputTarget.value.toLowerCase()

    this.productTargets.forEach(product => {
      const name = product.dataset.name.toLowerCase()
      const description = product.dataset.description.toLowerCase()
      const category = product.dataset.category

      const matchesCategory = this.activeCategory === "All" || category === this.activeCategory
      const matchesSearch = name.includes(query) || description.includes(query)

      if (matchesCategory && matchesSearch) {
        product.classList.remove("hidden")
      } else {
        product.classList.add("hidden")
      }
    })

    this.updateNoResults()
  }

  reset() {
    this.searchInputTarget.value = ""
    this.activeCategory = "All"

    this.categoryButtonTargets.forEach(btn => {
      if (btn.dataset.category === "All") {
        btn.classList.add("bg-blue-600", "text-white", "shadow-lg")
        btn.classList.remove("bg-slate-100", "text-slate-600", "hover:bg-slate-200")
      } else {
        btn.classList.remove("bg-blue-600", "text-white", "shadow-lg")
        btn.classList.add("bg-slate-100", "text-slate-600", "hover:bg-slate-200")
      }
    })

    this.applyFilters()
  }

  updateNoResults() {
    const visibleProducts = this.productTargets.filter(p => !p.classList.contains("hidden"))
    const noResults = document.getElementById("no-results")
    const productGrid = document.getElementById("product-grid")

    if (visibleProducts.length === 0) {
      noResults.classList.remove("hidden")
      productGrid.classList.add("hidden")
    } else {
      noResults.classList.add("hidden")
      productGrid.classList.remove("hidden")
    }
  }
}
